import React from 'react'
import { Box, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Avatar, Tooltip } from 'packages/eid-ui'
import PersonCard from './PerosnCard'
import PersonDetails from './PersonDetails'
import { isNilOrEmpty } from 'packages/core'

const StyledTypography = styled(Typography)(({ style }) => ({
    fontSize: '1.6rem',
    color: '#5d6870',
    maxWidth: '100%',
    ...style,
}))

const avatarStyles = {
    small: {
        width: '1.8rem',
    },
    medium: {
        width: '2.4rem',
    },
    large: {
        width: '4rem',
    },
}

const Person = (props) => {
    const {
        imgSrc,
        name,
        size = 'small',
        rootStyles,
        style,
        tooltipProps,
    } = props

    return (
        <Box position="relative" width="100%" sx={rootStyles}>
            {isNilOrEmpty(name) ? (
                <Box
                    sx={{
                        marginY: '0.75rem',
                        display: 'flex',
                        alignItems: 'center',
                        color: '#9b9b9b',
                    }}
                >
                    -
                </Box>
            ) : (
                <Box
                    sx={{
                        marginY: '0.75rem',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Box maxWidth={avatarStyles[size].width}>
                        <Avatar
                            src={imgSrc}
                            sx={{
                                width: avatarStyles[size].width,
                                height: avatarStyles[size].width,
                            }}
                        />
                    </Box>

                    <Tooltip
                        title={name ? name : ''}
                        enterDelay={800}
                        enterNextDelay={800}
                        placement="bottom-start"
                        disableInteractive={false}
                        {...tooltipProps}
                    >
                        <Box
                            sx={{
                                width: `calc(100% - ${avatarStyles[size].width})`,
                                marginLeft: '1rem',
                            }}
                        >
                            <StyledTypography noWrap style={style}>
                                {name}
                            </StyledTypography>
                        </Box>
                    </Tooltip>
                </Box>
            )}
        </Box>
    )
}

Person.Card = PersonCard
Person.Details = PersonDetails
export default Person
